import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { listAccessibleGroupsAPI } from "../store/features/listGroup";
import { fetchTeamsList } from "../store/features/teamsApi";
import { mapGroupListItem } from "../utils/teamMappers";

export default function useCustomerFormOptions({ includeTeams = true } = {}) {
  const dispatch = useDispatch();
  const [groupOptions, setGroupOptions] = useState([]);
  const [teamOptions, setTeamOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        const [groupsRes, teamsRes] = await Promise.all([
          dispatch(listAccessibleGroupsAPI()),
          includeTeams
            ? dispatch(fetchTeamsList({ optionsOnly: true }))
            : Promise.resolve(null),
        ]);
        if (cancelled) return;

        if (groupsRes?.payload?.status === 200) {
          setGroupOptions(
            (groupsRes.payload.data || []).map(mapGroupListItem).filter((g) => g.id)
          );
        }

        if (includeTeams) {
          const teams = teamsRes?.payload?.data;
          if (teamsRes?.payload?.status === 200 && Array.isArray(teams)) {
            setTeamOptions(teams.map((t) => ({ id: t.id, label: t.name })));
          }
        }
      } catch {
        if (!cancelled) {
          toast.error(includeTeams ? "Failed to load groups or teams" : "Failed to load groups");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [dispatch, includeTeams]);

  return { groupOptions, teamOptions, loading };
}
